import type { FlowId, StepId } from '../types';
import type { ContentKey } from '../constants/contentKeys';
import { getUiLocale } from '../utils/locale';

export type ContentPayload = {
  title?: string;
  body?: string[]; // paragraphs
  bullets?: string[];
};

class ContentAPI {
  private cache = new Map<string, ContentPayload>();

  private key(flow: FlowId, step: StepId, locale: string) {
    return `${flow}|${step}|${locale}`;
  }

  async get(flow: FlowId, step: StepId, locale: string = getUiLocale()): Promise<ContentPayload> {
    const k = this.key(flow, step, locale);
    if (this.cache.has(k)) {return this.cache.get(k)!;}
    try {
      const res = await fetch(`/api/content?flow=${encodeURIComponent(flow)}&step=${encodeURIComponent(step)}&locale=${encodeURIComponent(locale)}`);
      if (res.ok) {
        const json = await res.json();
        this.cache.set(k, json);
        return json;
      }
    } catch {}
    return {};
  }

  async getByKey(key: ContentKey, locale: string = getUiLocale()): Promise<ContentPayload> {
    return this.get(key.flow, key.step, locale);
  }
}

export const contentApi = new ContentAPI();
